import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Inject, Injectable, inject } from "@angular/core";
import type { IResponse } from "@kiraah-shared/common";
import { LvfAppModule, LvfOperationType, LvfRequestSource } from "@kiraah-shared/common";
import { ENVIRONMENT } from "@kiraah-shared/environment";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { MOBILE_GATEWAY_URL } from "../../auth/mobile-auth.config";
import { TenantAppMobileSummary } from "../../models/mobile-profile.models";
import { MobileAuthStore } from "../../state/mobile-auth.store";
import { MobileProfileStore } from "../../state/mobile-profile.store";

/**
 * Apps mobile autorisées pour l'utilisateur connecté (`GET /api/core/me/mobile-apps`).
 * Liste déjà filtrée par profil + plateforme MOBILE côté backend.
 */
@Injectable({ providedIn: "root" })
export class MobileConnectedAppsApiClient {
  private readonly http = inject(HttpClient);
  private readonly authStore = inject(MobileAuthStore);
  private readonly profileStore = inject(MobileProfileStore);
  private readonly environmentInfo = inject(ENVIRONMENT);

  private readonly mobileAppsUrl: string;

  constructor(@Inject(MOBILE_GATEWAY_URL) gatewayUrl: string) {
    this.mobileAppsUrl = `${gatewayUrl}/api/core/me/mobile-apps`;
  }

  getAuthorizedMobileApps(): Observable<TenantAppMobileSummary[]> {
    return this.http
      .get<IResponse<TenantAppMobileSummary[]>>(this.mobileAppsUrl, {
        headers: this.readHeaders(),
      })
      .pipe(
        map((response) => (response?.IsSuccessful && response.Data ? response.Data : []))
      );
  }

  private readHeaders(): HttpHeaders {
    const identityUid = `${this.authStore.authResult()?.ProfilData?.Identity?.Uid ?? ""}`;
    const appUid = `${this.profileStore.activeApplication()?.Uid ?? ""}`;
    return new HttpHeaders({
      "Content-Type": "application/json",
      "X-CONNECTED-IDENTITY-UID": identityUid,
      "X-USER-TOKEN-UID": "",
      "X-APP-UID": appUid,
      "X-APP-MODULE-UID": `${LvfAppModule.APPLICATION}`,
      "X-REQUEST-SRC": `${LvfRequestSource.MOBILE}`,
      "X-OPERATION-TYPE": `${LvfOperationType.READ}`,
      "X-WEB-APP-URL": `${this.environmentInfo.WebAppUrl ?? ""}`,
    });
  }
}
